import React, { useState, useEffect } from "react";

const MainSearchPanel = ({
  initialText = "",
  onSubmit,
  /** Called when the input value changes (empty string when cleared). */
  onQueryChange,
  searchMode,
  onSearchModeChange,
  /** Compact layout inside the home hero (shared search logic). */
  variant = "default",
}) => {
  const [local, setLocal] = useState(initialText);

  useEffect(() => {
    setLocal(initialText);
  }, [initialText]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(local.trim());
  };

  const handleChange = (e) => {
    const v = e.target.value;
    setLocal(v);
    onQueryChange?.(v);
  };

  const handleClear = () => {
    setLocal("");
    onQueryChange?.("");
  };

  const rootClass =
    variant === "hero"
      ? "gf-main-search gf-main-search--hero"
      : "gf-main-search";

  return (
    <div id="gf-search-anchor" className={rootClass}>
      <div className="gf-main-search__toolbar">
        <div className="gf-search-modes" role="tablist" aria-label="Search type">
          <button
            type="button"
            role="tab"
            aria-selected={searchMode === "developers"}
            className={`gf-search-modes__btn ${searchMode === "developers" ? "is-active" : ""}`}
            onClick={() => onSearchModeChange("developers")}
          >
            Developers
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={searchMode === "repositories"}
            className={`gf-search-modes__btn ${searchMode === "repositories" ? "is-active" : ""}`}
            onClick={() => onSearchModeChange("repositories")}
          >
            Repositories
          </button>
        </div>
      </div>

      <form className="gf-search-row gf-search-row--main" onSubmit={handleSubmit} role="search">
        <div className="gf-search-row__input-wrap">
          {variant === "hero" ? (
            <svg
              className="gf-search-row__icon gf-search-row__icon--hero"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M10.5 18a7.5 7.5 0 100-15 7.5 7.5 0 000 15zM16.5 16.5L21 21"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ) : (
            <span className="gf-search-row__icon" aria-hidden="true">
              🔍
            </span>
          )}
          <input
            type="search"
            name="q"
            className="gf-search-row__input"
            placeholder={
              variant === "hero"
                ? "Search GitHub users, repositories, or technologies…"
                : "Keywords, topics, technologies…"
            }
            autoComplete="off"
            value={local}
            onChange={handleChange}
            aria-label="Search GitHub"
          />
          {local.length > 0 && (
            <button
              type="button"
              className="gf-search-row__clear"
              onClick={handleClear}
              aria-label="Clear search"
            >
              ✕
            </button>
          )}
        </div>
        <button
          type="submit"
          className={
            variant === "hero"
              ? "gf-btn gf-btn--primary gf-search-row__btn gf-search-row__btn--hero"
              : "gf-btn gf-btn--primary gf-search-row__btn"
          }
        >
          Search
        </button>
      </form>
    </div>
  );
};

export default MainSearchPanel;
